export default __webpack_public_path__ + "static/media/img-0285-zambia-full-face.64b3e94b.png";